var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"activityguidepage"},[_vm._v(" 活动引导页 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }